module.exports = __webpack_public_path__ + "img/portrait-011.b1c6a7e5.jpg";